module.exports = __webpack_public_path__ + "static/img/bb-bottom.33cd63f4.png";